import { ViewConfiguration } from '../../../../grid/gridView/types';
import { ColumnDetails } from '../../../../grid/types/common';
import { QueryExecution } from '../../types';
import { IntEnumConditions } from '../../../../grid/gridFilters/types';
import { MetadataStatus } from '../../../common/types';

export enum Column {
  ENDPOINT,
  QUERY_EXECUTION_TIME,
  AVAILABLE_ROWS,
  SENT_ROWS,
  STATUS,
  ERROR_MESSAGE,
}

export enum ColumnKeys {
  ENDPOINT = 'endpoint',
  QUERY_EXECUTION_TIME = 'executionTime',
  AVAILABLE_ROWS = 'availableRows',
  SENT_ROWS = 'sentRows',
  STATUS = 'status',
  ERROR_MESSAGE = 'errorReason',
}

export const DEFAULT_PAGE_SIZE = 50;
export enum METADATA_FILTER_SENT_ROWS {
  NO_SENT_ROWS_RECEIVED,
  SENT_ROWS_RECEIVED,
}

export interface LiveSearchMetadataGridViewData {
  views: Array<ViewConfiguration<any, any>>;
  allColumns: Array<ColumnDetails<any, any>>;
  defaultViewProps: ViewConfiguration<any, any>;
  queryExecution: QueryExecution | null;
}

export interface LiveSearchMetadataGridGetRowsResponse {
  rawEvents?: Array<any>;
}

export const FILTERS = [
  {
    status: {
      in: [
        MetadataStatus.DISMISSED,
        MetadataStatus.DELIVERED,
        MetadataStatus.DELIVERED_WITH_ERROR,
        MetadataStatus.FAILED_SESSION_START,
      ],
    },
  },
  { sentRows: { in: [METADATA_FILTER_SENT_ROWS.SENT_ROWS_RECEIVED, METADATA_FILTER_SENT_ROWS.NO_SENT_ROWS_RECEIVED] } },
];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.STATUS, ColumnKeys.SENT_ROWS];

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface Filter {
  status?: IntEnumConditions;
  sentRows?: IntEnumConditions;
}

export const EXPORT_CSV_RESULT_METADATA_EVENT = 'exportCsvResultMetadata';
